import React, { type FC } from 'react';
import { RouterProvider } from '../../../context';
import { Footer } from '../footer';
import { Navbar } from '../navbar';
import type { LayoutProps } from './types';

const Layout: FC<LayoutProps> = ({ children, searchBarOnHeader = true, postTranslatedSlugs, ...router }) => (
    <RouterProvider {...router}>
        <div className="flex flex-col min-h-screen justify-between">
            <Navbar displaySearch={searchBarOnHeader} postTranslatedSlugs={postTranslatedSlugs} />
            <main className="min-h-screen flex-[1_0_auto] ">{children}</main>
            <div className="flex-shrink-0">
                <Footer />
            </div>
        </div>
    </RouterProvider>
);

export default Layout;
